// extracted by mini-css-extract-plugin
export default {"PagesTemplate":"PagesTemplate_PagesTemplate__fTUkX","LeftPanel":"PagesTemplate_LeftPanel__jVM4G","Child":"PagesTemplate_Child__ek7Bx"};